import axiosRequest from '@/utils/request'
import axios from 'axios'
// 查询用户激活等级
export const certifivateLevel = (params) => {
  return axiosRequest({
    url: '/wallet/certifivate-level',
    method: 'get',
    params
  })
}

// 查询收款用户信息
export const payeeUserInfo = (data) => {
  return axiosRequest({
    url: '/user/get-payee-user-info',
    method: 'post',
    showMessage: false,
    data
  })
}

// 交易详情
export const tradeDetail = (data, cancelToken) => {
  return axiosRequest({
    url: '/trade/trade-detail',
    method: 'post',
    data
  }, {
    cancelToken: new axios.CancelToken((cancel) => {
      cancelToken && cancelToken(cancel)
    })
  })
}

// 白名单功能
export const getAuth = (data) => {
  return axiosRequest({
    url: '/func-whitelist/without',
    method: 'post',
    data
  })
}
